﻿import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'antd';

import Modal from '/ui/Modal';

import AiIcon from '../../../../../components/AiIcon';

import AtlasTabContent from './AtlasTabContent';
import BinanceTabContent from './BinanceTabContent';
import Mt5TabContent from './Mt5TabContent';

const platformTabs = [
  { code: 'atlas' as const, nameId: 'files.atlasDownloadModal.tab.atlas' },
  { code: 'mt5' as const, nameId: 'files.atlasDownloadModal.tab.mt5' },
  { code: 'binance' as const, nameId: 'files.atlasDownloadModal.tab.binance' },
];

export type PlatformTab = (typeof platformTabs)[number]['code'];

type Props = {
  visible: boolean;
  onClose: () => void;
  platform?: PlatformTab;
};

const tabContentByPlatform: Record<PlatformTab, React.ReactNode> = {
  atlas: <AtlasTabContent />,
  mt5: <Mt5TabContent />,
  binance: <BinanceTabContent />,
};

const AtlasDownloadModal = ({
  visible,
  onClose,
  platform = 'atlas',
}: Props) => {
  const [selectedPlatform, setSelectedPlatform] =
    useState<PlatformTab>(platform);

  useEffect(() => {
    if (visible) {
      setSelectedPlatform(platform);
    }
  }, [visible, platform]);

  return (
    <Modal
      className="files-page__atlas-modal files-page__atlas-download-modal"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnHidden
      width={
        selectedPlatform === 'binance' || selectedPlatform === 'atlas'
          ? 1100
          : 896
      }
      title={
        <span className="files-page__atlas-download-title">
          <FormattedMessage id="files.atlasDownloadModal.title" />
        </span>
      }
    >
      <div className="files-page__atlas-download">
        <div className="files-page__atlas-download-main">
          <div className="files-page__atlas-download-selector">
            {platformTabs.map(({ code, nameId }) => (
              <Button
                key={code}
                className={`files-page__atlas-download-tab${
                  selectedPlatform === code
                    ? ' files-page__atlas-download-tab_active'
                    : ''
                }`}
                onClick={() => setSelectedPlatform(code)}
                icon={<AiIcon name={`download-${code}`} />}
              >
                <FormattedMessage id={nameId} />
              </Button>
            ))}
          </div>

          {tabContentByPlatform[selectedPlatform]}
        </div>

        {(selectedPlatform === 'atlas' || selectedPlatform === 'binance') && (
          <footer className="files-page__atlas-download-footer">
            <AiIcon name="download-macWarning" />
            <p className="files-page__atlas-download-footer-text">
              <FormattedMessage id="files.atlasDownloadModal.footerNote" />
            </p>
          </footer>
        )}
      </div>
    </Modal>
  );
};

export default AtlasDownloadModal;
